<template>
  <div class="privacy">
    <h2>{{header}}</h2>
    <div style="text-align:right;">{{time}}</div>
    <div style="text-align:right;">{{times}}</div>
    <div class="wl">
      <h3>{{ts}}</h3>
      <p
        v-for="(item,i) in list"
        :key="i"
      >
        {{item.name}}
      </p>
      <h3>{{content}}</h3>
      <p
        v-for="(item,i) in contentList"
        :key="i"
      >
        {{item.name}}
      </p>
      <h3>{{sm}}</h3>
      <h4>{{one}}</h4>
      <p
        v-for="(item,i) in oneList"
        :key="i"
      >
        {{item.name}}
      </p>
      <h4>{{two}}</h4>
      <p
        v-for="(item,i) in numoneList"
        :key="i"
      >
        {{item.name}}
      </p>
      <h4>{{three}}</h4>
      <p>
        {{three_one}}
      </p>
      <h3>{{hide}}</h3>
      <p
        v-for="(item,i) in numthreeList"
        :key="i"
      >
        {{item.name}}
      </p>
      <h4>{{numberone}}</h4>
      <p
        v-for="(item,i) in numberlist"
        :key="i"
      >
        {{item.name}}
      </p>
      <h4>{{numbertwo}}</h4>
      <h4>{{number_one}}</h4>
      <p
        v-for="(item,i) in number_onelist"
        :key="i"
      >
        {{item.name}}
      </p>
      <h4>{{number_two}}</h4>
      <p
        v-for="(item,i) in number_twolist"
        :key="i"
      >
        {{item.name}}
      </p>
      <h3>{{numberthree}}</h3>
      <h4>{{number_three}}</h4>
      <p
        v-for="(item,i) in number_threelist"
        :key="i"
      >
        {{item.name}}
      </p>
      <h4>{{three_two}}</h4>
      <p
        v-for="(item,i) in three_two_list"
        :key="i"
      >
        {{item.name}}
      </p>
      <h4>{{three_three}}</h4>
      <p
        v-for="(item,i) in three_three_list"
        :key="i"
      >
        {{item.name}}
      </p>
      <h4>{{three_four}}</h4>
      <p
        v-for="(item,i) in three_four_list"
        :key="i"
      >
        {{item.name}}
      </p>
      <h3>{{four}}</h3>
      <h4>
        {{fourtext}}
      </h4>
      <h4>{{four_one}}</h4>
      <p
        v-for="(item,i) in four_one_list"
        :key="i"
      >
        {{item.name}}
      </p>
      <h4>{{four_two}}</h4>
      <p
        v-for="(item,i) in four_two_list"
        :key="i"
      >
        {{item.name}}
      </p>
      <h3>{{five}}</h3>
      <p
        v-for="(item,i) in five_list"
        :key="i"
      >
        {{item.name}}
      </p>
      <h3>{{seven}}</h3>
      <p
        v-for="(item,i) in seven_list"
        :key="i"
      >
        {{item.name}}
      </p>
      <h3>{{eight}}</h3>
      <p
        v-for="(item,i) in eight_list"
        :key="i"
      >
        {{item.name}}
      </p>
      <h3>{{nine}}</h3>
      <p
        v-for="(item,i) in nine_list"
        :key="i"
      >
        {{item.name}}
      </p>
      <h3>{{ten}}</h3>
      <p
        v-for="(item,i) in ten_list"
        :key="i"
      >
        {{item.name}}
      </p>
      <br>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      header:this.$t('privacy.header'),
      time: this.$t('privacy.time'),
      times: this.$t('privacy.times'),
      ts: this.$t('privacy.ts'),
      list: this.$t('privacy.list'),
      content: this.$t('privacy.content'),
      contentList: this.$t('privacy.contentList'),
      sm: this.$t('privacy.sm'),
      //  一、
      one: this.$t('privacy.one'),
      oneList: this.$t('privacy.oneList'),
      // 二、
      two: this.$t('privacy.two'),
      numoneList: this.$t('privacy.numoneList'),
      // 三、
      three: this.$t('privacy.three'),
      three_one: this.$t('privacy.three_one'),
      hide: this.$t('privacy.hide'),
      numthreeList:this.$t('privacy.numthreeList'),
      numberone: this.$t('privacy.numberone'),
      numberlist: this.$t('privacy.numberlist'),
      numbertwo: this.$t('privacy.numbertwo'),
      number_one: this.$t('privacy.number_one'),
      number_onelist:this.$t('privacy.number_onelist'),
      number_two: this.$t('privacy.number_two'),
      number_twolist: this.$t('privacy.number_twolist'),
      numberthree: this.$t('privacy.numberthree'),
      number_three: this.$t('privacy.number_three'),
      number_threelist: this.$t('privacy.number_threelist'),
      three_two: this.$t('privacy.three_two'),
      three_two_list: this.$t('privacy.three_two_list'),
      three_three:this.$t('privacy.three_three'),
      three_three_list:this.$t('privacy.three_three_list'),
      three_four: this.$t('privacy.three_four'),
      three_four_list: this.$t('privacy.three_four_list'),
      // 四
      four: this.$t('privacy.four'),
      fourtext:this.$t('privacy.fourtext'),
      four_one: this.$t('privacy.four_one'),
      four_one_list:this.$t('privacy.four_one_list'),
      four_one_text:this.$t('privacy.four_one_text'),
      four_two:this.$t('privacy.four_two'),
      four_two_list: this.$t('privacy.four_two_list'),
      // 五、
      five: this.$t('privacy.five'),
      five_list:this.$t('privacy.five_list'),
      // 六、
      six: this.$t('privacy.six'),
      six_list: this.$t('privacy.six_list'),
      seven: this.$t('privacy.seven'),
      seven_list: this.$t('privacy.seven_list'),
      eight: this.$t('privacy.eight'),
      eight_list: this.$t('privacy.eight_list'),
      nine:  this.$t('privacy.nine'),
      nine_list:  this.$t('privacy.nine_list'),
      ten: this.$t('privacy.ten'),
      ten_list: this.$t('privacy.ten_list'),
    };
  }
};
</script>
<style lang="scss" scoped>
.privacy {
  padding: 0 40px;
  h2 {
    font-weight: 700;
  }
  p {
    line-height: 1.6;
    margin-left: 10px;
  }
}
</style>
